import React from 'react';
import './App.css';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import RblKycProccess  from "./on-boarding/pages/rbl.home.pages";
import IciciKycProccess  from "./on-boarding/pages/icici.home.pages";

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 ,  currentUser: null };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
  }
  
  componentWillUnmount() {
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  
  }


  render() {    
    return (
      <>
       <div className="main">
       <Router>
         <Switch>
           <Route exact path="/rbl/kycProcess" component={RblKycProccess} />
           <Route exact path="/icici/kycProcess" component={IciciKycProccess} />
          </Switch>
        </Router>
        </div>
      </>
    );
  }
} 

export default App;
